import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress as MUICircularProgress, styled, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
export const StyledProgress = styled(MUICircularProgress)(() => ({
    "&.MuiCircularProgress-root": {
        borderRadius: convertPxToRem(99),
    },
}));
export const CircularProgress = ({ color = "green06", disableShrink = false, size = "default", testId, }) => (_jsx(StyledProgress, { color: color, disableShrink: disableShrink, size: size === "default" ? convertPxToRem(32) : convertPxToRem(20), thickness: 4, "data-testid": testId }));
